export default {
      id: "i-wallet-white-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-wallet-white",
      toString: function () {
        return this.url;
      }
    }